const KEYS = {
  userId: 'as_user_id',
  accessToken: 'as_access_token',
  refreshToken: 'as_refresh_token',
  deviceUuid: 'as_device_uuid',
  watcherName: 'as_watcher_name',
  language: 'as_language',
  appChipDismissed: 'as_app_chip_dismissed',
} as const;

export type StorageKey = keyof typeof KEYS;

export function getItem(key: StorageKey): string | null {
  try {
    return localStorage.getItem(KEYS[key]);
  } catch {
    return null;
  }
}

export function setItem(key: StorageKey, value: string): void {
  try {
    localStorage.setItem(KEYS[key], value);
  } catch {
    // localStorage may be unavailable (private mode, quotas) — degrade silently
  }
}

export function clearAuth(): void {
  try {
    localStorage.removeItem(KEYS.userId);
    localStorage.removeItem(KEYS.accessToken);
    localStorage.removeItem(KEYS.refreshToken);
  } catch {
    // ignore
  }
}

export function getOrCreateDeviceUuid(): string {
  const existing = getItem('deviceUuid');
  if (existing) return existing;
  const uuid = crypto.randomUUID();
  setItem('deviceUuid', uuid);
  return uuid;
}
